module.exports = __webpack_public_path__ + "a8d39aff282ecc259a9343d68bc28a5f-811_4_2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/eightOneOne/assets/811_4_2x.png
// module id = 617
// module chunks = 0